import React from 'react'

// import { Container } from './styles';

function Calendar() {
  return (
    <div className="mdn-Calendar" data-mdn-selected-day="31" data-mdn-selected-month="august" data-mdn-selected-year="2020">
    <div className="mdn-Calendar-header">
      <div className="mdn-Input mdn-Input--activatedField mdn-Calendar-header-month">
        <select id="calendar-month" className="mdn-Input-field" type="text" data-mdn-type="select">
          <option value="january">Janeiro</option>
          <option value="february">Fevereiro</option>
          <option value="march">Março</option>
          <option value="april">Abril</option>
          <option value="may">Maio</option>
          <option value="june">Junho</option>
          <option value="july">Julho</option>
          <option value="august">Agosto</option>
          <option value="september">Setembro</option>
          <option value="october">Outubro</option>
          <option value="november">Novembro</option>
          <option value="december">Dezembro</option>
        </select>
        <label htmlFor="calendar-month" className="mdn-Input-label">Mês</label>
        <small className="mdn-Input-errorFeedback">Por favor, preencha este campo corretamente.</small>
      </div>
      <div className="mdn-Input mdn-Input--activatedField mdn-Calendar-header-year">
        <select id="search" className="mdn-Input-field" type="text" data-mdn-type="select">
          <option value="2018">2018</option>
          <option value="2019">2019</option>
          <option value="2020">2020</option>
          <option value="2021">2021</option>
          <option value="2022">2022</option>
          <option value="2022">2022</option>
          <option value="2023">2023</option>
        </select>
        <label htmlFor="search" className="mdn-Input-label">Ano</label>
        <small className="mdn-Input-errorFeedback">Por favor, preencha este campo corretamente.</small>
      </div>
    </div>
    <div className="mdn-Calendar-body">
      <ul className="mdn-Calendar-weekDays">
        <li className="mdn-Calendar-weekDays-day" aria-label="Domingo">DOM</li>
        <li className="mdn-Calendar-weekDays-day" aria-label="Segunda-Feira">SEG</li>
        <li className="mdn-Calendar-weekDays-day" aria-label="Terça-Feira">TER</li>
        <li className="mdn-Calendar-weekDays-day" aria-label="Quarta-Feira">QUA</li>
        <li className="mdn-Calendar-weekDays-day" aria-label="Quinta-Feira">QUI</li>
        <li className="mdn-Calendar-weekDays-day" aria-label="Sexta-Feira">SEX</li>
        <li className="mdn-Calendar-weekDays-day" aria-label="Sábado">SÁB</li>
      </ul>
      <ul className="mdn-Calendar-weeks">

      </ul>
    </div>
  </div>
  )
}

export default Calendar
